import type {PromiseRunnerOptions, PromiseRunnerType} from "../../util/promises/PromiseRunner.tsx";
import type {Setter} from "../../util/setter/Setter.ts";
import {Field} from "@matillion/component-library";
import {SimpleSelect} from "../../components/select/SimpleSelect.tsx";
import {useFieldSetter} from "../../util/setter/FieldSetter.ts";
import type {ChangeEvent} from "react";

const Types: PromiseRunnerType[] = ["SERIAL", "PARALLEL"]
function toType(type: string): PromiseRunnerType {
    if(type.toLowerCase() === "serial") return "SERIAL"
    return "PARALLEL"
}

function safeNum(v: number): number {
    if(isNaN(v) || v < 1) return 1
    if(v > 10) return 10
    return Math.round(v)
}

interface Props {
    title: string
    description?: string
    options: PromiseRunnerOptions
    setOptions: Setter<PromiseRunnerOptions>
    disabled?: boolean
}
export function PromiseRunnerOptionsWidget({title, description, options, setOptions, disabled = false}: Props) {
    const [type, setType] = useFieldSetter(options, setOptions, "type")
    const [limit, setLimit] = useFieldSetter(options, setOptions, "parallelLimit")
    return <>
        <Field title={title}
               description={description}
               value={type}
               onChange={(e: string) => setType(toType(e))}
               disabled={disabled} >
            <SimpleSelect value={type} onChange={(v)=>setType(toType(v))} options={Types} disabled={disabled} />
        </Field>
        <Field title={title + " Parallel Limit"}
               disabled={disabled || type !== "PARALLEL"}
               type="number"
               min={1}
               max={10}
               value={limit} onChange={(e: ChangeEvent<HTMLInputElement>) => setLimit(safeNum(e.target.valueAsNumber))} />
    </>
}